import React, { useState } from 'react';
import './VideoManager.scss';

const VideoManager = () => {
  const [videos, setVideos] = useState([
    {
      id: 1,
      title: "Benefits of Organic Vegetables",
      description: "Learn why organic vegetables are better for your health",
      videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
      category: "Health Benefits"
    },
    {
      id: 2,
      title: "How to Store Fresh Organic Produce",
      description: "Tips to keep your organic vegetables fresh longer",
      videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
      category: "Storage Tips"
    },
    {
      id: 3,
      title: "Organic vs Conventional: The Difference",
      description: "Understanding the difference between organic and conventional farming",
      videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
      category: "Education"
    }
  ]);

  const [editingVideo, setEditingVideo] = useState(null);

  const handleEdit = (video) => {
    setEditingVideo({...video});
  };

  const handleSave = () => {
    setVideos(videos.map(v => v.id === editingVideo.id ? editingVideo : v));
    setEditingVideo(null);
    alert('Video updated! Note: You need to update the VideoPlaylist.js file with these URLs for them to appear on the website.');
  };

  const handleCancel = () => {
    setEditingVideo(null);
  };

  const extractVideoId = (url) => {
    const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
    return match ? match[1] : null;
  };

  const getThumbnailUrl = (videoUrl) => {
    const videoId = extractVideoId(videoUrl);
    return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : '';
  };

  return (
    <div className="video-manager">
      <h2>Manage Educational Videos</h2>
      <p className="instructions">
        Update your YouTube video URLs here. After uploading videos to your channel, 
        replace the placeholder URLs with your actual video links.
      </p>

      <div className="videos-list">
        {videos.map(video => (
          <div key={video.id} className="video-item">
            {editingVideo && editingVideo.id === video.id ? (
              <div className="edit-form">
                <div className="form-group">
                  <label>Title:</label>
                  <input
                    type="text"
                    value={editingVideo.title}
                    onChange={(e) => setEditingVideo({...editingVideo, title: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <label>Description:</label>
                  <textarea
                    value={editingVideo.description}
                    onChange={(e) => setEditingVideo({...editingVideo, description: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <label>YouTube URL:</label>
                  <input
                    type="url"
                    value={editingVideo.videoUrl}
                    onChange={(e) => setEditingVideo({...editingVideo, videoUrl: e.target.value})}
                    placeholder="https://www.youtube.com/watch?v=..."
                  />
                </div>
                <div className="form-group">
                  <label>Category:</label>
                  <select
                    value={editingVideo.category}
                    onChange={(e) => setEditingVideo({...editingVideo, category: e.target.value})}
                  >
                    <option value="Health Benefits">Health Benefits</option>
                    <option value="Storage Tips">Storage Tips</option>
                    <option value="Education">Education</option>
                    <option value="Recipes">Recipes</option>
                    <option value="Farming">Farming</option>
                  </select>
                </div>
                <div className="form-actions">
                  <button className="save-btn" onClick={handleSave}>Save</button>
                  <button className="cancel-btn" onClick={handleCancel}>Cancel</button>
                </div>
              </div>
            ) : (
              <div className="video-display">
                <div className="video-thumbnail">
                  <img src={getThumbnailUrl(video.videoUrl)} alt={video.title} />
                  <div className="video-category">{video.category}</div>
                </div>
                <div className="video-details">
                  <h3>{video.title}</h3>
                  <p>{video.description}</p>
                  <div className="video-url">
                    <strong>URL:</strong> {video.videoUrl}
                  </div>
                  <button className="edit-btn" onClick={() => handleEdit(video)}>
                    Edit Video
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="instructions-box">
        <h3>How to Update Videos:</h3>
        <ol>
          <li>Upload your videos to YouTube</li>
          <li>Copy the YouTube video URL (e.g., https://www.youtube.com/watch?v=ABC123)</li>
          <li>Click "Edit Video" above and paste your URL</li>
          <li>Update title, description, and category</li>
          <li>Click "Save"</li>
          <li>The thumbnail will automatically update from YouTube</li>
        </ol>
        <p><strong>Note:</strong> Changes here are for preview only. To make them live on your website, 
        you need to update the VideoPlaylist.js component with the new URLs.</p>
      </div>
    </div>
  );
};

export default VideoManager;